import { render, staticRenderFns } from "./SupplierUsersForm.vue?vue&type=template&id=f20a3fde&"
import script from "./SupplierUsersForm.vue?vue&type=script&lang=js&"
export * from "./SupplierUsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports